import menu from './menu.js'
import home from './home.js'
import seo from './seo.js'
import errors from './errors.js'

export default {
  menu,
  home,
  seo,
  errors,
}
